<div class="modal-dialog" role="document">
    <div class="modal-content">
      <app-loadconfirm *ngIf="showSpinner" [text]="'orgsettings.settingsloader' | trans " [icon]="'pending'"></app-loadconfirm>
      <div class="modal-header">
        <h5 class="modal-title">{{ 'usersettings.usersettingsheader' | trans }}</h5>
        <button #closebutton type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body">
       <form>
        <div class="form-group">
            <label for="LanguageSelect"><p class="mb-0">{{ 'usersettings.systemlanguage' | trans }}</p></label>
            <select class="form-control" id="LanguageSelect" name="language" [(ngModel)]="usersettings.personlanguage">
              <option value="default">{{ 'usersettings.default' | trans }}</option>
              <option value="EN">{{ 'usersettings.english' | trans }}</option>
              <option value="DA">{{ 'usersettings.danish' | trans }}</option>
              <option value="SE">{{ 'usersettings.swedish' | trans }}</option>
              <option value="NO">{{ 'usersettings.norwegian' | trans }}</option>
              <option value="FI">{{ 'usersettings.finnish' | trans }}</option>
            </select>
          </div>
       </form>
       <div *ngIf="updated" class="alert alert-success" role="alert">
        {{ 'usersettings.updated' | trans }}
      </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-close" data-dismiss="modal"><p class="btn-save-text">{{ 'usersettings.close' | trans }}</p></button>
        <button type="button" class="btn-save" (click)="updateUserSettings()"><p class="btn-save-text">{{ 'usersettings.savechanges' | trans }}</p></button>
      </div>
    </div>
  </div>
